import jQuery from 'jquery';
window.$ = jQuery;
jQuery(function() {

    function fn_ValidateIBAN(IBAN) {

        //Se pasa a Mayusculas
        IBAN = IBAN.toUpperCase();
        //Se quita los blancos de principio y final.
        IBAN = IBAN.trim();
        IBAN = IBAN.replace(/\s/g, ""); //Y se quita los espacios en blanco dentro de la cadena
    
        var letra1,letra2,num1,num2;
        var isbanaux;
        var numeroSustitucion;
        //La longitud debe ser siempre de 24 caracteres
        if (IBAN.length != 24) {
            return false;
        }
    
        // Se coge las primeras dos letras y se pasan a números
        letra1 = IBAN.substring(0, 1);
        letra2 = IBAN.substring(1, 2);
        num1 = getnumIBAN(letra1);
        num2 = getnumIBAN(letra2);
        //Se sustituye las letras por números.
        isbanaux = String(num1) + String(num2) + IBAN.substring(2);
        // Se mueve los 6 primeros caracteres al final de la cadena.
        isbanaux = isbanaux.substring(6) + isbanaux.substring(0,6);
    
        //Se calcula el resto, llamando a la función modulo97, definida más abajo
        var resto = modulo97(isbanaux);
        if (resto == 1){
            return true;
        }else{
            return false;
        }
    }

    function modulo97(iban) {
        var parts = Math.ceil(iban.length/7);
        var remainer = "";
    
        for (var i = 1; i <= parts; i++) {
            remainer = String(parseFloat(remainer+iban.substr((i-1)*7, 7))%97);
        }
    
        return remainer;
    }
    
    function getnumIBAN(letra) {
        var lsletras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        return lsletras.search(letra) + 10;
    }

    //ESTA FUNCION SE LLAMA CUANDO PULSAMOS EL BOTON DE GUARDAR LA CONFIGURACION DEL NEGOCIO
    $("#guardar_negocio_config").on('click', function() {
        var tpanel_dashboard_url = $("#tpanel_dashboard_url").val();
        var submit = tpanel_dashboard_url + '/negocios/' + $("#negocio_id").val() + '/update';
        var type_request = 'PUT';

        //if (validarDNI($("#nif").val())==false) {
        //    alert('El NIF no es válido');
        //    return;
        //}
        if (fn_ValidateIBAN($("#iban").val()) == false){
            alert("El IBAN no es válido");
            return;
        }

        var formData = {
            nombre_fiscal: $("#nombre_fiscal").val(),
            nif : $("#nif").val(),
            enabled: $("#enabled").val(),
            direccion_1: $("#direccion_1").val(),
            direccion_2: $("#direccion_2").val(),
            cp: $("#cp").val(),
            localidad: $("#localidad").val(),
            provincia: $("#provincia").val(),
            iban: $("#iban").val(),
            nombre_empresa: $("#nombre_empresa").val(),
            nombre_contacto: $("#nombre_contacto").val(),
            telefono: $("#telefono").val(),
            email_propietario: $("#email_propietario").val(),
            email_facturas: $("#email_facturas").val(),
            facturacion_albaranes: $("#facturacion_albaranes").val(),
            comision_intermediacion: $("#comision_intermediacion").val(),
            comision_minima: $("#comision_minima").val(),
            comision_maxima: $("#comision_maxima").val(),
            penalizacion_cancelacion: $("#penalizacion_cancelacion").val(),
        };

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: type_request,
            url: submit,
            data: formData,
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    $.each( data.errors, function( key, value) {
                        alert(key + " " + value)
                    });

                } else {
                    window.location.href =  tpanel_dashboard_url + '/inicio';
                }
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    //ESTA FUNCION SE LLAMA CUANDO PULSAMOS EL BOTON DE GUARDAR LA CONFIGURACION DEL NEGOCIO
    $("#guardar_economics").on('click', function() {
        var tpanel_dashboard_url = $("#root_url").val();
        var submit = tpanel_dashboard_url + '/updateeconomics';
        var type_request = 'POST';

        var formData = {
            comision_intermediacion: $("#comision_intermediacion").val(),
            comision_minima : $("#comision_minima").val(),
            comision_maxima: $("#comision_maxima").val(),
            penalizacion_cancelacion: $("#penalizacion_cancelacion").val(),
        };

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: type_request,
            url: submit,
            data: formData,
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    $.each( data.errors, function( key, value) {
                        alert(key + " " + value)
                    });

                } else {
                    location.reload();
                }
            },
            error: function (data) {
                console.log(data);
            }
        });
    });


    function esNumeroTelefono(numero) {
     // Expresión regular para un número de teléfono con 9 dígitos
     const patron = /^\d{9}$/;
   
     // Comprobación si el número coincide con el patrón
     return patron.test(numero);
    }




    $("#crear_tendero_bo").on('click', function() {
        var boton = document.getElementById("crear_tendero_bo");
        boton.innerHTML = "Procesando...";
        boton.disabled = true; 

        var tpanel_dashboard_url = $("#root_url").val();
        var submit = tpanel_dashboard_url + '/creartenderobo';
        var type_request = 'POST';

        if ($("#nombre_fiscal").val() == '' || $("#nif").val() == '' || $("#direccion_1").val() == '' || $("#cp") == '' || $("#localidad").val() == '' || $("#provincia").val() == '' || $("#iban").val() == '' || $("#nombre_empresa").val() == '' || $("#nombre_contacto").val() == '' || $("#email_facturas").val() == '' || $("#facturacion_albaranes").val() == '' || $("#telefono").val() == ''){
            alert('Hay campos vacios que debe rellenar');
            boton.innerHTML = "Guardar cambios";
            boton.disabled = false; 
            return;
        }

        if (esNumeroTelefono($("#telefono").val()) ==false){
          alert('El número de teléfono no es válido');
          boton.innerHTML = "Registrarse";
          boton.disabled = false; 
          return;
        }

        //if (validarDNI($("#nif").val())==false) {
        //    alert('El NIF no es válido');
        //    return;
        //}
        if (fn_ValidateIBAN($("#iban").val()) == false){
            boton.innerHTML = "Guardar cambios";
            boton.disabled = false; 
            alert("El IBAN no es válido");
            return;
        }

        
        var form = document.getElementById('crear_tenderobo_form');
        form.submit();
    return;
    var formData = {
            nombre_fiscal: $("#nombre_fiscal").val(),
            nif : $("#nif").val(),
            direccion_1: $("#direccion_1").val(),
            direccion_2: $("#direccion_2").val(),
            cp: $("#cp").val(),
            localidad: $("#localidad").val(),
            provincia: $("#provincia").val(),
            iban: $("#iban").val(),
            nombre_empresa: $("#nombre_empresa").val(),
            nombre_contacto: $("#nombre_contacto").val(),
            telefono: $("#telefono").val(),
            email_propietario: $("#email_propietario").val(),
            email_facturas: $("#email_facturas").val(),
            facturacion_albaranes: $("#facturacion_albaranes").val(),
        };

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: type_request,
            url: submit,
            data: formData,
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    boton.innerHTML = "Guardar cambios";
                    boton.disabled = false; 
                    $.each( data.errors, function( key, value) {
                        alert(value)
                    });
                    boton.innerHTML = "Guardar cambios";
                    boton.disabled = false; 

                } else {
                    window.location.href =  tpanel_dashboard_url + '/helpdesk?message=Tendero%20creado%20correctamente%2C%20Status%20NO%20ACTIVO';
                }
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    $("#actualizar_tendero_bo").on('click', function() {
        var boton = document.getElementById("actualizar_tendero_bo");
        boton.innerHTML = "Procesando...";
        boton.disabled = true; 

        var tpanel_dashboard_url = $("#root_url").val();
        var submit = tpanel_dashboard_url + '/actualizartenderobo';
        var type_request = 'POST';

        if ($("#nombre_fiscal").val() == '' || $("#nif").val() == '' || $("#direccion_1").val() == '' || $("#cp") == '' || $("#localidad").val() == '' || $("#provincia").val() == '' || $("#iban").val() == '' || $("#nombre_empresa").val() == '' || $("#nombre_contacto").val() == '' || $("#email_facturas").val() == '' || $("#facturacion_albaranes").val() == '' || $("#comision_intermediacion").val() == '' || $("#comision_minima").val() == '' || $("#comision_maxima").val() == ''|| $("#penalizacion_cancelacion").val() == ''){
            alert('Hay campos vacios que debe rellenar');
            boton.innerHTML = "Guardar cambios";
            boton.disabled = false; 
            return;
        }

        //if (validarDNI($("#nif").val())==false) {
        //    alert('El NIF no es válido');
        //    return;
        //}
        if (fn_ValidateIBAN($("#iban").val()) == false){
            alert("El IBAN no es válido");
            boton.innerHTML = "Guardar cambios";
            boton.disabled = false; 
            return;
        }

        var formData = {
            id: $("#id").val(),
            nombre_fiscal: $("#nombre_fiscal").val(),
            enabled: $("#enabled").val(),
            nif : $("#nif").val(),
            direccion_1: $("#direccion_1").val(),
            direccion_2: $("#direccion_2").val(),
            cp: $("#cp").val(),
            localidad: $("#localidad").val(),
            provincia: $("#provincia").val(),
            iban: $("#iban").val(),
            nombre_empresa: $("#nombre_empresa").val(),
            nombre_contacto: $("#nombre_contacto").val(),
            telefono: $("#telefono").val(),
            email_propietario: $("#email_propietario").val(),
            email_facturas: $("#email_facturas").val(),
            facturacion_albaranes: $("#facturacion_albaranes").val(),
            comision_intermediacion: $("#comision_intermediacion").val(),
            comision_minima: $("#comision_minima").val(),
            comision_maxima: $("#comision_maxima").val(),
            penalizacion_cancelacion: $("#penalizacion_cancelacion").val(),
            email_login: $("#email_login").val(),
        };

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            type: type_request,
            url: submit,
            data: formData,
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    boton.innerHTML = "Guardar cambios";
                    boton.disabled = false; 
                    alert(data.error);
                    boton.innerHTML = "Guardar cambios";
                    boton.disabled = false; 

                } else {
                    //window.location.href =  tpanel_dashboard_url + '/helpdesk?message=Tendero%20creado%20correctamente%2C%20Status%20NO%20ACTIVO';
                    var nuevaURL = window.location.href.split('?')[0] + '?message=Tendero%20actualizado%20correctamente';
                    window.location.href = nuevaURL;
                }
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    function cumpleRequisitosPassword(password) {
      const tieneMayuscula = /[A-Z]/.test(password);
      const tieneMinuscula = /[a-z]/.test(password);
      const tieneNumero = /\d/.test(password);
      const tieneLongitudSuficiente = password.length >= 8;
      
      // Verificar si la contraseña cumple todos los requisitos
      return tieneMayuscula && tieneMinuscula && tieneNumero && tieneLongitudSuficiente;
    }

    function validarDNI(dni) {
      const letras = "TRWAGMYFPDXBNJZSQVHLCKE";
      
      dni = dni.toUpperCase();
      
      if (/^[0-9]{8}[A-Z]$/.test(dni)) {
        const numero = dni.substr(0, dni.length - 1);
        const letra = dni.substr(dni.length - 1);
        const letraCalculada = letras[numero % 23];
        
        return letra === letraCalculada;
      } else {
        return false;
      }
    }
    
});
